export function FormataStringCurrencyToNumber(valor: any): number {
    if (typeof (valor) === 'number') {
        return valor;
    }
    if (isNaN(Number(valor.toString().replace('R$', '').replace('.', '').replace(',', '.')))) {
        return 0;
    } else {
        return Number(valor.toString().replace('R$', '').replace('.', '').replace(',', '.'))
    }
}